import { render, staticRenderFns } from "./MissingStatementWidget.vue?vue&type=template&id=e460b054&"
import script from "./MissingStatementWidget.vue?vue&type=script&lang=js&"
export * from "./MissingStatementWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports